/* eslint-disable camelcase */
import { ConfigProvider } from 'antd';
import {} from 'antd/locale';
import { FC, ReactNode } from 'react';
import ru_RU from 'antd/locale/ru_RU';
import { theme } from '../model/theme';

interface ThemeProviderProps {
    children: ReactNode
}

export const ThemeProvider:FC<ThemeProviderProps> = (props) => {
  const { children } = props;
  return (
    <ConfigProvider theme={theme} locale={ru_RU}>
      {children}
    </ConfigProvider>
  );
};
